import { Row, Col, Image } from "antd";

export const AnandaCollege = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="ananda-college">Ananda College - 250 Million Donation</h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            Philanthropist and entrepreneur{" "}
            <strong>Eng. Nahil Wijesuriya</strong> donated
            <strong>Rs. 250 million</strong> to establish Sri Lanka’s first
            <strong>public-sector STEAM Education Center</strong> at
            <strong>Ananda College, Colombo</strong>.
          </p>

          <p>
            The initiative forms a key part of the school’s
            <strong>Rs. 410 million Centre of Excellence (COE)</strong>, created
            to foster innovation, creativity, and critical thinking through an
            integrated
            <strong>
              Science, Technology, Engineering, Arts, and Mathematics (STEAM)
            </strong>
            approach and <em>hands-on, inquiry-driven</em> learning.
          </p>

          <p>
            Led by the <strong>Old Anandians’ Professional Forum (OAPF)</strong>{" "}
            with the
            <strong>Ananda College Old Boys’ Association (ACOBA)</strong>, the
            historic
            <strong>Pasmahala building</strong> was restored and modernized to
            host
            <strong>ten specialized learning hubs</strong> including robotics,
            programmable drones, Internet of Things (IoT), algorithms, and other
            advanced technologies.
          </p>

          <p>
            Nearly <strong>100 academic and industry experts</strong>{" "}
            contributed to the curriculum, aligning it with national education
            reforms. The project is supported by the{" "}
            <strong>Ministry of Education</strong> and is intended to operate as
            a<strong>national hub</strong>, open to students and institutions
            across Sri Lanka.
          </p>

          <p>
            The COE shifts away from rote instruction to activity-based learning
            that builds creativity, problem-solving, leadership, and
            entrepreneurship—preparing students for real-world challenges and
            future careers.
          </p>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/1r_8mCCzMto?si=CNdcoQBxj5b-e0XT"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/73-Ananda-College/poster-of-donation.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>News Wire</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/73-Ananda-College/center-of-excellence-nahil.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>News Wire</small>
              </p>
            </div>
          </div>
        </Col>
        <p>ADD CMC ALBUM</p>
      </Row>
    </div>
  );
};
